const ADMIN_STATS = {
  SET_HOME_STATS_QUERY: 'SET_HOME_STATS_QUERY',
  SET_HOME_STATS_MONTH_QUERY: 'SET_HOME_STATS_MONTH_QUERY',
  SET_AVG_COMMUTE_DISTANCE_STATS_QUERY: 'SET_AVG_COMMUTE_DISTANCE_STATS_QUERY_ADMIN',
  SET_AVG_COMMUTE_MODE_DISTANCE_STATS_QUERY: 'SET_AVG_COMMUTE_MODE_DISTANCE_STATS_QUERY_ADMIN',
  SET_EMPLOYER_FILTER_ID: 'SET_EMPLOYER_FILTER_ID',
};

export default ADMIN_STATS;
